import { render, staticRenderFns } from "./menuList.vue?vue&type=template&id=f103d51c&scoped=true"
import script from "./menuList.vue?vue&type=script&lang=js"
export * from "./menuList.vue?vue&type=script&lang=js"
import style0 from "./menuList.vue?vue&type=style&index=0&id=f103d51c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f103d51c",
  null
  
)

export default component.exports